import React, {useEffect, useState} from 'react';
import {Button, Col, Image, Row} from 'react-bootstrap';
import ShareLinkModal from '../../components/ShareLinkModal';
import './style.css';

const convert_src = (src) => {
    if(!src){
        return '';
    }

    if (src.indexOf('data:image')>-1 || src.indexOf('http')>-1 || src.indexOf('blob:')>-1) {
        if(src.indexOf('blob:')>-1 || src.indexOf('data:image')>-1){
            return src;  
        }else{
            return global.config.server_path.replace('api/','')+'api/image_proxy?src='+window.encodeURIComponent(src)
        }
    } else {
        return global.config.server_path + src
    }
}
		
class Loader {
    static activate = () => {
        var rp = {
            w: window.document.getElementById('result_preview').clientWidth, 
            h: window.document.getElementById('result_preview').clientHeight
        };
        var rc = {
            w: window.document.getElementById('result_container').clientWidth, 
            h: window.document.getElementById('result_container').clientHeight
        };
        window.document.getElementById('result_overlay').style.width = Math.ceil(100 * rp.w / rc.w) + '%';
        window.document.getElementById('result_overlay').style.height = Math.ceil(100 * rp.h / rc.h) + '%';
        window.document.getElementById('result_overlay').style.marginLeft = Math.floor(100 * ((rc.w - rp.w) / 2) / rc.w) + '%';
        window.document.getElementById('result_loader').style.display = 'block';
        window.document.getElementById('result_overlay').style.display = 'block';
    }

    static hide = () => {
        if (window.document.getElementById('result_loader')) {
            window.document.getElementById('result_loader').style.display = 'none'
        }
        if (window.document.getElementById('result_overlay')) {
            window.document.getElementById('result_overlay').style.display = 'none'
        }
    }

    static initialize = () => {
        var loader_elements = window.document.getElementsByClassName("bodymovin");
        const loadBMAnimation = loader_element => {
            var animation = window.bodymovin.loadAnimation({
                container: loader_element,
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: global.config.server_path + "uploads/loader-dai-small.json"
            });
        }

        for (var i = 0; i < loader_elements.length; i++) {
            loadBMAnimation(loader_elements[i]);
        }
    }
}


const DesignInfoPanel = ({ design, device_type, user, copy_into_saved_design, redirect_page }) => {
	try {

        const openInNewTab = (url) => {
            var win = window.open(url, '_blank');
            win.focus();
        }

		const result_container_style = {
            padding: 0,
            backgroundColor: 'white', 
            maxWidth: 'calc(100% - 362px)', 
            maxHeight: 'calc(100vh - 100px)'
        };

        const result_container_style_tablet = {
            ...result_container_style,
            maxWidth: '100%',
            maxHeight: 'auto',
            marginTop: 0
        }; 

        const result_preview_style = {
            margin: 'auto', 
            width: 'auto', 
            maxWidth: '100%', 
            maxHeight: 500, 
            display: 'block'
        };

        const [ loader_init, set_loader_init ] = useState(false);
        const [ fonts, set_fonts ] = useState([]);
        const [ colors, set_colors ] = useState([]);
        const [ show_share_modal, set_show_share_modal ] = useState(false);

        const load_design = async () => {
            try {
                // console.log('design found ===> ', design);
                let design_instance = new window.DM_Design();
                design_instance.load(design.design_file);
                var design_colors = design_instance.findDominantColors();
                var design_fonts = design_instance.getAllFonts();
                set_colors(design_colors);
                set_fonts(design_fonts);
            } catch (err) {
                console.log(err);
                return 'error loading design';
            }
        }

        useEffect(() => {
            if (design) {
                load_design();
            }
        }, [ design ])

		return design ? (
			<Row>
                <ShareLinkModal 
                    show_share_modal={show_share_modal}
                    hide_share_modal={() => set_show_share_modal(false)}
                    template_id={design._id}
                    custom_url={design.custom_url}
                />
                {device_type == 'tablet' ? (<Col xs={2} />) : ''}
                <Col xs={12} sm={8} id="result_container" style={device_type == 'tablet' ? result_container_style_tablet : result_container_style}>
                    <div id="result_loader" className="bodymovin-wrapper loader" style={{ display: 'none' }} />
                    <div id="result_overlay" className="bodymovin loader_overlay" style={{ display: 'none' }} />
                    <Image 
                        id="result_preview" 
                        style={result_preview_style} 
                        className="mockup_image_big" 
                        src={convert_src(design.thumbnail)} 
                        rounded
                    />
                    <Row style={{ marginTop: 15 }}>
                        {design.keywords.split(',').map((keyword => (
                            <div onClick={() => openInNewTab('/designmaker/start/search?query='+keyword)} style={{ cursor: 'pointer', display: 'inline-block', marginTop: 10, fontSize: 16, borderRadius: 3, padding: 10, paddingTop: 10, paddingBottom: 10, marginRight: 10, backgroundColor: '#f1f2f3' }}>{keyword}</div>    
                        )))}
                    </Row>
                </Col>
                

                {device_type == 'tablet' ? (<Col xs={4} style={{ marginLeft: '-44px' }} />) : ''}
                <Col xs={12} sm={4} style={{minWidth: 338}}>
                    <div style={{ marginTop: 0, width: '100%', padding: 20, float:'right', marginLeft: 24 }}>
                        <Row>
                            <span style={{ fontSize: 24, fontFamily: 'Montserrat', fontWeight: 600, lineHeight: '32px' }}>{design.name}</span>
                        </Row>
                        {design.categories && design.categories.length && (
                            <>
                                <Row style={{marginTop: 14}}>
                                    <span style={{ fontSize: 16, fontFamily: 'Montserrat', fontWeight: 500, color: '#8c8c8c', lineHeight: '24px' }}>{design.categories[0].name}</span>
                                </Row>
                                <Row>
                                    <span style={{ fontSize: 16, fontFamily: 'Montserrat', fontWeight: 500, color: '#8c8c8c', lineHeight: '24px' }}>Dimension: {design.categories[0].dimensions.height} x {design.categories[0].dimensions.width} {design.categories[0].dimensions.unit}</span>
                                </Row>
                            </>
                        )}
                        <Row>
                            <Row style={{ marginTop: 28, marginBottom: 14 }}>
                                <Row>
                                    <Button onClick={() => copy_into_saved_design({ id: design._id, category_id: design.categories && design.categories.length ? design.categories[0].id : null})} className="btn-block btn-orange" style={{ fontSize: 16, padding: 12, fontWeight: 500 }}>Use this template</Button>
                                </Row>                                
                                <Row style={{marginTop: 25}}>
                                    <span style={{cursor: 'pointer'}} onClick={() => set_show_share_modal(true)}><span className="fa fa-share-alt" style={{ marginLeft: 20, marginRight: 20}}/> <span style={{ fontSize: 16, fontWeight: 600, lineHeight: '24px', letterSpacing: 0 }}>Share this template</span></span>
                                </Row>                                
                            </Row>
                        </Row>
                    </div>
                </Col>

                {(colors && colors.length) ? (
                    <Col xs={12} style={{ marginTop: 45 }}>
                        <span style={{ fontSize: 21, fontWeight: 600 }}>Colors</span><br />
                        {colors.map((color => (
                            <div style={{ display: 'inline-block', marginTop: 10, fontSize: 16, borderRadius: 3, padding: 40, marginRight: 10, backgroundColor: color }}></div>    
                        )))}
                    </Col>
                ):(<></>)}

                {(fonts && fonts.length) ? (
                    <Col xs={12} style={{ marginTop: 45 }}>
                        <span style={{ fontSize: 21, fontWeight: 600 }}>Fonts</span><br/>
                        {fonts.map(((font, idx) => (
                            <div style={{ display: 'inline-block', marginTop: 5, fontSize: 18, borderRadius: 3, paddingTop: 10, paddingBottom: 10 }}> {font.font}{idx == fonts.length - 1 ? "" : ",\u00a0"} </div>    
                        )))}
                    </Col>
                ):(<></>)}
            </Row>	
		) : (<></>);
	} catch(err) {
		console.log('error in DesignInfoPanel => ', err);
		return 'oops something went wrong';
	}
}

export default DesignInfoPanel;